import { absolutePath } from "./absolutePath";

interface CopilotFnProps {
  id?: string | number;
}

export const copilot = {
  getCopilotDeepLink: ({ id }: CopilotFnProps) =>
    absolutePath(`copilot_deep_links/${id}`),
};
